import { ActivityTimeRange, IActivityLogBase } from '@shared/services/activity-service/activity.models';

export class DropDownFilter {
    constructor(public searchTerm: string, public entityType: EntityType, public eventId: string = null) {
    }
}

export enum EntityType {
    Contact = 0,
    User = 1,
    Event = 2
}

export class IDropDownItem {
    id: string;
    text: string;
}

export class AttendeeActivityFilter {
    constructor(public timeRange: ActivityTimeRange, public category: ActivityCategory = null,
        public searchAttendee: string = null,
        public searchEvent: string = null,
        public searchVenue: string = null) { }
}

export enum ActivityCategory {
    CheckIn = 0,
    CheckOut = 1,
    NoShow = 2,
    Confirmed = 3,
    Declined = 4
}

export interface IDropDownItems {
    entities: IDropDownItem[];
}

export enum AttendeeType {
    Invitee = 0,
    ExtraGuest = 1,
}

export interface IAttendeeActivityLog  extends IActivityLogBase {
    venueName: string;
    eventName: string;
    showExtraGuests: boolean;
    inviteeName: string;
    inviteeEmail: string;
    attendeeName: string;
    attendeeEmail: string;
    attendeeType: AttendeeType;
    attendees: Attendee[];
    attendeesLabel: string;
    attendeeNames: string[];
    isContactCreated: boolean;
    eventUsesFieldDrive: boolean;
}

export interface Attendee {
    email: string;
    name: string;
    type: AttendeeType;
}

export interface IAttendeeActivityLogs {
    activities: IAttendeeActivityLog[];
}
